<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <h1 *ngIf="data.title">{{ data.title }}</h1>
  <h1 *ngIf="!data.title">{{ 'T4.Settings.ManageCategories.lblFindUser' | translate : 'Find user' }}</h1>
  <div class="searchUser">
    <div>
      <mat-form-field style="width: 480px;" appearance="outline">
        <input matInput placeholder="{{ 'Turbo.Settings.RightsManagement.SearchForUser' | translate : 'Search for user' }}" [matAutocomplete]="userAC" [formControl]="txtUser">
        <mat-autocomplete #userAC="matAutocomplete">
          <mat-option *ngFor="let item of filteredUsers | async" [value]="item.UserName ? item.UserName + ' - ' : '' + item.Email" (onSelectionChange)="selectUser(item)">
            <span *ngIf="item.UserName">{{item.UserName}} - </span><span *ngIf="item.Email">{{item.Email}}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="col-12" style="text-align: right; padding-left: 5px; padding-right: 5px;">
      <button mat-flat-button color="primary" style="margin: 3px;" [mat-dialog-close]="selectedUser" [disabled]="!selectedUser">
        <span *ngIf="data.saveButtonText">{{ data.saveButtonText }}</span>
        <span *ngIf="!data.saveButtonText">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.cmdAddToGroup' | translate : 'Add to group' }}</span>
      </button>
      <button mat-flat-button color="primary" style="margin: 3px;" [mat-dialog-close]>
        {{'Turbo.OneWayAdmin.ServiceDialog.Actions.cmdCancel' | translate : 'Cancel' }}
      </button>
    </div>
</mat-dialog-actions>
<mat-progress-bar mode="indeterminate" style="margin-left: -24px; margin-bottom: -24px; width: calc(100% + 48px); margin-top: 24px;" *ngIf="false"></mat-progress-bar>
